import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AmministrazioneRoutingModule} from './amministrazione-routing.module';
import { AmministrazioneService } from './aministrazione.service';
import { APIKEY_ENDPOINT, apiKeyStateConfig } from './amministrazione.config';
import { provideQuerySentrynelService } from 'src/app/core/services/query-sentrynel.service';
import { provideQueryService } from 'src/app/core/services/query.service';
import { IApiKey } from './models/api-key.model';
import { UtentiService } from './utenti.service';
import { UTENTI_ENDPOINT, utentiStateConfig } from './utenti.config';
import { IUtente } from './models/utenti.model';
import { UserRoleService } from './user-role.service';
import { IUserRole } from './models/user-role.model';
import { USERROLES_ENDPOINT, userRolesStateConfig } from './user-role.config';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AmministrazioneRoutingModule,
  ],
  providers: [
    ...provideQueryService<IApiKey>(APIKEY_ENDPOINT, apiKeyStateConfig),
    ...provideQuerySentrynelService<IUtente>(UTENTI_ENDPOINT, utentiStateConfig),
    ...provideQueryService<IUserRole>(USERROLES_ENDPOINT, userRolesStateConfig),
    UserRoleService,
    AmministrazioneService,
    UtentiService
  ],
})
export class AmministrazioneModule {
}
